import { useEffect, useState } from "react";
import { TournamentItmResponse } from "../../../../../api/tournament";
import {
  TournamentItmBack,
  TournamentItmItem,
  TournamentItmWrapper,
} from "../../styled/tournament-itm";
import Pagination from "../../../../../components/web/Pagination";
import { PubType } from "../../../../../api/types";
import { TournamentType } from "../../../../../dataset";

interface TournamentStateItmProps {
  itm: TournamentItmResponse[];
  pubType: PubType;
  tournamentType: TournamentType;
}
const TournamentStateItm = ({
  itm,
  pubType,
  tournamentType,
}: TournamentStateItmProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [list, setList] = useState<TournamentItmResponse[]>([]);

  useEffect(() => {
    setTotalPages(Math.max(1, Math.ceil(itm.length / 10)));
    setList(itm.slice((currentPage - 1) * 10, currentPage * 10));
  }, [itm]);

  useEffect(() => {
    setList(itm.slice((currentPage - 1) * 10, currentPage * 10));
  }, [currentPage]);

  const handelPrize = (item: TournamentItmResponse) => {
    if (pubType !== "RUNNER") {
      if (item.isSubPrize) {
        return item.subPrize;
      }
      return item.prize.toLocaleString();
    }
    if (tournamentType === TournamentType.Tournament)
      return item.prize.toLocaleString();
    if (/^\d+$/.test(item.subPrize)) {
      return Number(item.subPrize).toLocaleString();
    }
    return item.subPrize;
  };
  return (
    <TournamentItmWrapper>
      <div className="header">ITM 순위</div>
      <TournamentItmBack isItm={true}>
        <div className="table">
          <div className="header">
            <div className="item">순위</div>
            <div className="item">닉네임</div>
            <div className="item">프라이즈</div>
          </div>
          <div className="body">
            {list.map((item, index) => (
              <TournamentItmItem key={index}>
                <div className="item">{item.rank}</div>
                <div className="item">{item.nickname}</div>
                <div className="item">{handelPrize(item)}</div>
              </TournamentItmItem>
            ))}
          </div>
        </div>
        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            size={22}
          ></Pagination>
        )}
      </TournamentItmBack>
    </TournamentItmWrapper>
  );
};
export default TournamentStateItm;
